import React, { FC, ReactNode } from "react";
import { ImageDetail } from "../ImageDetail";
import { Customization } from "../../../../../types/graphql/generated";
import { StyledGatoradeIdBottleLidDetails, StyledTitle } from "./index.styled";

const getGatoradeIdBottleLidDetails = ({
  bottleLidLogoImage,
  bottleLidNumber,
  bottleLidNumberType,
  bottleLidFeatureText,
}: {
  bottleLidLogoImage?: string | null;
  bottleLidNumber?: string | null;
  bottleLidNumberType?: string | null;
  bottleLidFeatureText?: string | null;
}) => {
  // text and logo
  if (
    bottleLidFeatureText &&
    bottleLidNumberType === "logo" &&
    bottleLidLogoImage
  ) {
    return (
      <StyledGatoradeIdBottleLidDetails>
        <div data-testid="lid-text">{bottleLidFeatureText}</div>
        <ImageDetail data-testid="lid-logo" value={bottleLidLogoImage} />
      </StyledGatoradeIdBottleLidDetails>
    );
  }
  // text and number
  if (
    bottleLidFeatureText &&
    bottleLidNumberType === "number" &&
    bottleLidNumber
  ) {
    return (
      <StyledGatoradeIdBottleLidDetails>
        <div data-testid="lid-text">{`${bottleLidFeatureText},`}</div>
        <div data-testid="lid-number">{bottleLidNumber}</div>
      </StyledGatoradeIdBottleLidDetails>
    );
  }
  // logo only
  if (bottleLidNumberType === "logo" && bottleLidLogoImage) {
    return <ImageDetail data-testid="lid-logo" value={bottleLidLogoImage} />;
  }
  // number only
  if (bottleLidNumberType === "number" && bottleLidNumber) {
    return <div data-testid="lid-number">{bottleLidNumber}</div>;
  }
  // text only
  if (bottleLidFeatureText)
    return <div data-testid="lid-text">{bottleLidFeatureText}</div>;
  return;
};

const getLidText = (number: number) => (number > 1 ? "lids" : "lid");

export const LidDetails: FC<{ customizations: Customization[] }> = ({
  customizations,
}) => {
  const lidDetails: ReactNode[] = [];
  let blankLids = 0;
  let diyLids = 0;

  customizations.forEach((cust, i) => {
    const type = cust.__typename;

    if (type === "GatoradeIdBottle") {
      const {
        bottleLidFeatureText,
        bottleLidFeatureType,
        bottleLidLogoImage,
        bottleLidNumber,
        bottleLidNumberType,
      } = cust;

      if (bottleLidFeatureType === "diy_strip") {
        diyLids++;
        return;
      } else if (bottleLidFeatureType === "blank") {
        blankLids++;
        return;
      }

      const lidText = getGatoradeIdBottleLidDetails({
        bottleLidLogoImage,
        bottleLidNumber,
        bottleLidNumberType,
        bottleLidFeatureText,
      });

      if (lidText) {
        lidDetails.push(<div key={`customization-${i}`}>{lidText}</div>);
      } else blankLids++;

      return;
    } else if (type === "LegacyCustomization") {
      const { number, text } = cust || {};
      const lidText =
        !!text && !!number ? `${text}, ${number}` : `${text || number || ""}`;

      if (lidText) {
        lidDetails.push(<div key={`lid-customization-${i}`}>{lidText}</div>);
      } else {
        blankLids++;
      }

      return;
    }
  });

  if (!!lidDetails.length || blankLids || diyLids) {
    return (
      <>
        <StyledTitle>Lid</StyledTitle>
        {lidDetails.map((lidDetail) => lidDetail)}
        {!!blankLids && (
          <div data-testid="lid-blank">
            +{blankLids} blank {getLidText(blankLids)}
          </div>
        )}
        {!!diyLids && (
          <div data-testid="lid-diy">
            +{diyLids} {getLidText(diyLids)} with space to hand write
          </div>
        )}
      </>
    );
  }

  return null;
};
